

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"silentTranslationWarn":true,"silentFallbackWarn":true},
  vueI18nLoader: false,
  locales: [{"code":"en","name":"English","domain":"www.vexels.com","file":"languages.js","iso":"en"},{"code":"de","name":"Deutsch","domain":"de.vexels.com","file":"languages.js","iso":"de"},{"code":"es","name":"Español","domain":"es.vexels.com","file":"languages.js","iso":"es"},{"code":"pt","name":"Português","domain":"br.vexels.com","file":"languages.js","iso":"pt"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "/usr/src/app/locales",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: true,
  seo: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncLocale":true,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"en","name":"English","domain":"www.vexels.com","file":"languages.js","iso":"en"},{"code":"de","name":"Deutsch","domain":"de.vexels.com","file":"languages.js","iso":"de"},{"code":"es","name":"Español","domain":"es.vexels.com","file":"languages.js","iso":"es"},{"code":"pt","name":"Português","domain":"br.vexels.com","file":"languages.js","iso":"pt"}],
  localeCodes: ["en","de","es","pt"],
}

export const localeMessages = {
  'languages.js': () => import('../../locales/languages.js' /* webpackChunkName: "lang-languages.js" */),
}
